import { tickerItems } from "@/mocks/home";

export default function TopTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex h-9 max-w-[1440px] items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
          <span className="relative flex h-1.5 w-1.5 items-center justify-center">
            <span className="absolute inline-flex h-1.5 w-1.5 rounded-full bg-background-50 animate-hl-ping" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-background-50" />
          </span>
          实时更新
        </span>

        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-hl-marquee items-center gap-8 whitespace-nowrap">
            {loopItems.map((item, index) => (
              <span
                key={`ticker-${index}`}
                className="flex items-center gap-2 text-xs text-background-200"
              >
                <i className="ri-arrow-right-up-line text-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>

        <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-300 md:flex font-label">
          <i className="ri-calendar-line" />
          2026-09-10
        </span>
      </div>
    </div>
  );
}